// import ObjectId from "ObjectId";
import $ from "jquery";

import UserStore from "stores/UserStore";

const sidebarKey = "reader.sidebar";
const tabKey = "reader.sidebar.tab";

type Value = "expanded" | "collapsed";

export const persistentMode = () => $(window).width() > 1100;

const defaultSetting = (user: UserStore): Value => {
  if (user.state.value.acheivements?.includes("readerSidebar")) {
    // These are existing users who've already used the sidebar at least once, so default to
    // collapsed
    return "collapsed";
  }

  // This is a user who has never seen the sidebar, so default to expanded
  return "expanded";
};

export const isExpanded = (user: UserStore) => {
  const value = localStorage.getItem(sidebarKey) ?? defaultSetting(user);
  return value === "expanded";
};

export const setExpanded = (expanded: boolean) => {
  localStorage.setItem(sidebarKey, expanded ? "expanded" : "collapsed");
};

export const setTab = (tab: string) => {
  if (!["smartDictionary", "dictionary", "guide", "editWord"].includes(tab)) {
    return;
  }

  localStorage.setItem(tabKey, tab);
};

export const getTab = () => {
  return localStorage.getItem(tabKey) ?? "smartDictionary";
};
